import { graphql } from 'gatsby';
import { Box, Heading } from 'lucid-components-react';
import React from 'react';

import LucidContainer from 'components/lucid-container/lucid-container';
import NineteenCta, {
  nineteenCtaThemes
} from 'components/nineteen/nineteen-cta/nineteen-cta';
import { Drupal_ParagraphNineteenTextCta } from 'generated/graphql';
import { LucidTheme } from 'types/types';

interface Props {
  entity: Drupal_ParagraphNineteenTextCta;
}

const NineteenTextCta = ({
  entity: { fieldHeading, fieldSingleCta }
}: Props) => (
    /* eslint-disable-next-line react/jsx-indent */
    <Box
      as="section"
      className="nineteen-text-cta"
      pb={{ default: 8, tablet: 10 }}
      pt={{ default: 6, tablet: 7 }}
    >
      <LucidContainer
        flex
        css={theme => ({
          alignItems: 'center',
          flexWrap: 'wrap',
          [`@media screen and (min-width: ${theme.breakpoints.mobile})`]: {
            flexWrap: 'nowrap'
          }
        })}
      >
        <Heading
          as="h1"
          css={(theme: LucidTheme) => ({
            marginBottom: `${theme.space[4]}px`,
            flex: '0 1 100%',
            [`@media screen and (min-width: ${theme.breakpoints.mobile})`]: {
              marginBottom: 0,
              flex: '0 1 60%',
              paddingRight: `${theme.space[3]}px`
            },
            [`@media screen and (min-width: ${theme.breakpoints.tablet})`]: {
              flex: '0 1 80%'
            }
          })}
          variant="subheadL"
        >
          {fieldHeading}
        </Heading>
        <Box css={{ flex: '0 1 auto' }}>
          {fieldSingleCta && (
            <NineteenCta
              primary
              entity={fieldSingleCta.entity!}
              theme={nineteenCtaThemes.inverse}
            />
          )}
        </Box>
      </LucidContainer>
    </Box>
  );

export default NineteenTextCta;

export const query = graphql`
  fragment nineteenTextCta on Drupal_ParagraphNineteenTextCta {
    entityId
    fieldHeading
    fieldSingleCta {
      entity {
        ...nineteenCta
      }
    }
  }
`;
